import * as React from "react";
const SvgImpactRadius = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 120"
    width="1em"
    height="1em"
    {...{ ...props, ref }}
  >
    <path d="M0 0h45v110H0V0Z" fill="#FCFBFB" />
    <path
      d="M29.25 3.625c4.712 2.656 7.492 6.039 10.063 10.813C40.986 20.675 40.025 25.367 37 31c-3.814 4.535-7.565 7.52-13.547 8.355-5.829.298-10.013-.354-14.797-3.785C5.96 33.014 4.583 30.355 3 27l-1-2c-.668-5.38-.337-9.777 2.656-14.363 6.488-7.902 14.8-11.49 24.594-7.012Z"
      fill="#F53540"
    />
    <path
      d="M29.25 68.625c4.86 2.75 7.658 6.141 10.125 11.188 1.173 5.984.523 11.129-2.438 16.5C34.032 100.459 30.89 102.677 26 104c-7.147.987-12.22.364-18-4-4.196-4.423-6.079-8.371-6.313-14.438.166-5.256 1.41-8.646 5.188-12.449 6.733-6.102 13.681-8.464 22.375-4.488Z"
      fill="#030303"
    />
    <path
      d="M29.375 46.188C34.388 49.648 37.855 53.24 40 59c.405 3.871.241 7.277-1 11-2.954-.634-5.39-1.6-8.063-3-5.32-2.778-10.029-4.123-16.03-2.398C11.502 65.859 8.192 67.27 5 69v2H3C1.331 65.994.904 60.67 2.941 55.707c5.995-10.017 15.285-13.442 26.434-9.52Z"
      fill="#ABB5BE"
    />
  </svg>
);
export default React.forwardRef(SvgImpactRadius);
